import type { ChatToken } from "schemas/generated/chatMessage";

import * as React from "react";

import { AssetToken } from "@v2/features/chat/components/chat-elements/chat-tokens/AssetToken";
import { IntegrationToken } from "@v2/features/chat/components/chat-elements/chat-tokens/IntegrationToken";
import { ProductToken } from "@v2/features/chat/components/chat-elements/chat-tokens/ProductToken";
import { exhaustiveSwitch } from "replo-utils/lib/misc";

export default function ChatTokenComponent({ token }: { token: ChatToken }) {
  return exhaustiveSwitch(token)({
    product: ({ data }) => <ProductToken data={data} />,
    asset: ({ data }) => <AssetToken data={data} />,
    integration: ({ data }) => <IntegrationToken data={data} />,
    "integration-object": () => null,
    // Note (Noah, 2025-09-19): Currently we don't support adding a selected element
    // token directly inline in chat, so this is null
    "selected-element": () => null,
  });
}
